import { PaymentMethod } from '../../../../../store/workspace/types';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import {
    setEditCardModal,
    setDeleteCardModal,
    setSelectedPaymentMethod,
} from '../../../../../store/workspace/slice';

interface Props {
    paymentMethod: PaymentMethod;
};

/** One saved card, with the actions that act on that very card. */
export default function Card({ paymentMethod }: Props) {
    const dispatch = useDispatch();

    /** Both modals read the card back from the store, so select it first. */
    const editCard = () => {
        dispatch(setSelectedPaymentMethod(paymentMethod));
        dispatch(setEditCardModal(true));
    };

    const deleteCard = () => {
        dispatch(setSelectedPaymentMethod(paymentMethod));
        dispatch(setDeleteCardModal(true));
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>{paymentMethod.card.brand}</span>
            <span className={styles.detail}>
                Credit card ending in **** {paymentMethod.card.last4}
            </span>
            <div className={styles.actions}>
                <span className={styles.actions_edit} onClick={editCard}>
                    Edit
                </span>
                <span className={styles.actions_devider} />
                <span className={styles.actions_delete} onClick={deleteCard}>
                    Delete
                </span>
            </div>
        </div>
    );
};
